import { ajax } from '@/api/ajax';

export type GetAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPostApiResponse = CodeNameResp[];

export interface CodeNameResp {
  children?: object[];
  /**
   * 故障描述编码
   */
  code?: string;
  /**
   * 故障描述名称
   */
  name?: string;
}

/**
 * @operationId getAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPOST
 * @tags Toc手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/Toc%E6%89%8B%E5%86%8C/getAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPOST
 */
export function getAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPost() {
  return ajax<GetAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPostApiResponse>({
    url: '/api/tis/web/allOperatePlaceAndWiType',
    method: 'post'
  });
}

// 国际工时大类小类
export function getAllOperatePlaceAndWiTypeEu() {
  return ajax<GetAllFaultPartCodeAndOperatePlaceAndWiTypeUsingPostApiResponse>({
    url: '/api/tis/web/wi/allOperatePlaceAndWiType',
    method: 'post'
  });
}
